import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ArchivoService {

  private url = `${environment.baseUrlAPIDWH}/file`;

  constructor(private http: HttpClient) { }

  upload = (nombreArchivo: string, archivo: any) => {
    const formData = new FormData();

    formData.append("nombreArchivo", nombreArchivo);
    formData.append("file", archivo);

    return this.http.post(`${this.url}/upload-pdf`, formData, {
      headers: { 'Upload-File': 'true' },
      reportProgress: true,
      observe: 'events'
    });
  }

  verPdf = (nombre: string, nombreOpcional: string = null) => {

    const url = `${this.url}/ver-pdf?nombre=${nombre}&&nombreOpcional=${nombreOpcional || nombre}`

    window.open(url);
  }
}
